export default __webpack_public_path__ + "static/media/minus-circle.561bb84e.svg";